enum OverlayState {
  NONE = 'NONE',
  PAUSED = 'PAUSED',
  SYNCING = 'SYNCING',
  UNSTARTED = 'UNSTARTED',
}

export default OverlayState;
